import {Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, Output, signal} from '@angular/core';
import { SelectBrandItem } from '../../../services/dashboard.service';
import { FormControl } from '@angular/forms';
import { SelectMenuComponent, SelectMode } from '../../../shared/components/select-menu/select-menu.component';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { TippyDirective } from '@ngneat/helipopper';
import { PremiumTooltipComponent } from '../../../shared/components/premium-tooltip/premium-tooltip.component';
import { tooltips } from '../../../utils/tooltips';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-brand-chip-add-button',
  imports: [
    ButtonComponent,
    SelectMenuComponent,
    TippyDirective,
    PremiumTooltipComponent,
    CommonModule
  ],
  templateUrl: './brand-chip-add-button.component.html',
  styleUrl: './brand-chip-add-button.component.scss'
})
export class BrandChipAddButtonComponent implements OnChanges{
  @Input() isTrialUser = false;
  @Input() brandsOptions?: SelectBrandItem[] = [];
  @Output() brandSelected = new EventEmitter<string>();

  protected class: string = '';
  protected isExpanded = false;
  protected isPanelOpen = signal(this.isExpanded);
  protected control: FormControl<string|null> = new FormControl<string|null>(null);
  protected readonly SelectMode = SelectMode;
  protected readonly tooltips = tooltips;

  constructor(private elementRef: ElementRef) {}

  ngOnChanges(): void {
    this.class = this.trialCondition ? 'disabled' : 'primary';
    this.control.setValue(null);
  }

  toggleExpanded(): void {
    if (this.trialCondition) return;
    this.isExpanded = !this.isExpanded;
    this.isPanelOpen.set(this.isExpanded);
  }

  onBrandSelected(brandKey: string | null): void {
    if (!brandKey) return;
    this.brandSelected.emit(brandKey);
    this.control.setValue(null);
    this.isExpanded = false;
    this.isPanelOpen.set(false);
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const clickedInside = this.elementRef.nativeElement.contains(event.target);
    if (!clickedInside) {
      this.isExpanded = false;
      this.isPanelOpen.set(this.isExpanded);
    }
  }

  get trialCondition(): boolean {
    return this.isTrialUser && this.brandsOptions?.length === 0;
  }
}
